import { createSelector } from '@reduxjs/toolkit';
import type { TRootState } from 'src/store/store-types';

const selectUser = (state: TRootState) => state.entities.user.user;

export const selectUserName = createSelector([selectUser], (user) => user.userName);

export const selectUserEmail = createSelector([selectUser], (user) => user.email);
